import { Component, OnInit, Inject } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as moment from 'moment';


@Component({
  selector: 'app-status-modal',
  templateUrl: './status-modal.component.html'
})
export class StatusModalComponent implements OnInit {
  savingFlag: boolean = false;
  segment: any = {};
  category: any = {};
  login: any = {};
  delivery_from: any;
  userData: any;
  userId: any;
  vocherData: any = [];
  userName: any;
  salesUser: any = [];
  assignDistArray: any = [];
  drlist: any = [];
  tmpOrderStatus: any = '';
  segmentList: any = [];
  today_date  = new Date().toISOString().slice(0, 10);



  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog, public serve: DatabaseService, public session: sessionStorage, public toast: ToastrManager, public dialogRef: MatDialogRef<StatusModalComponent>) {
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    this.segment = this.data.segment;
    this.data.partial_dispatch_date = new Date();
    this.userId = this.userData['data']['id'];
    this.userName = this.userData['data']['name'];
    this.delivery_from = this.data.delivery_from;
    console.log(data);
    this.tmpOrderStatus = this.data.order_status;
    console.log(this.tmpOrderStatus);
    if (this.tmpOrderStatus) {
      this.data.order_status = '';
      this.data.reason = '';
      }
  }

  ngOnInit() {
    if (this.delivery_from == 'assignDist') {
      this.distributorDetail();
      this.distributorList('', this.data.state)

    } else if (this.delivery_from == 'assignSales') {
      this.distributorDetail();
      this.getSalesUser('')
    }
    else if (this.delivery_from == 'Event_report' || this.delivery_from=='Attendance_report') {
      this.getSalesUser('')
    }
    else if (this.delivery_from == 'subcategory-list') {
      this.data.segment_id = this.data.master_category_id.toString();
      this.getSegment();
    }
    else if (this.delivery_from == 'edit_travel_plan_retailer') {
      this.data.employee_id = this.data.employee_id.toString();
      this.data.id = this.data.travel_plan_id.toString();
      this.data.distributor_id = this.data.drId.toString();
      this.allCustomerNetworkList('');
    }
    this.login = JSON.parse(localStorage.getItem('login'));
  }
  reason_reject: any
  primary_order_status_change(reason, status) {
    this.savingFlag = true;
    this.serve.post_rqst({ 'reason': reason, 'status': status, 'id': this.data.order_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName, 'voucher_name': this.data.vocher_name, 'partial_amount': this.data.partial_amount || '0' , 'partial_dispatch_date':this.data.partial_dispatch_date, }, "Order/primaryOrderStatusChange").subscribe((result => {


      if (result['statusCode'] == 200) {

        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg'])
      }

    }))

  }

  getCompanyData() {
    this.serve.post_rqst({}, "Order/voucher_list").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.vocherData = response['result'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }

  public onDate(event): void {
    this.data.partial_dispatch_date = moment(event.value).format('YYYY-MM-DD');
  }


  secondary_order_status_change(reason, status) {
    this.savingFlag = true;
    this.serve.post_rqst({ 'reason': reason, 'status': status, 'id': this.data.order_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Order/secondaryOrderStatusChange").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }
  apiName:any=''
  DownloadReport(delivery_from) {
    // Format dates only if they are selected
    if (this.data.start_date) {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
    }
    if (this.data.end_date) {
        this.data.end_date = moment(this.data.end_date).format('YYYY-MM-DD');
    }
    if(delivery_from=='Event_report'){this.apiName="Excel/EventReport"}
    else{this.apiName="Excel/AttendanceRangeReport"}
    this.savingFlag = true;

    this.serve.post_rqst(
        {
            "start_date": this.data.start_date || '',
            "end_date": this.data.end_date || '',
            'user_id': this.data.assigned_sales_user_name
        },this.apiName).subscribe((result: any) => {
        this.savingFlag = false;
        if (result['msg'] == true) {
            window.open(this.serve.downloadUrl + result['filename']);
        }
    }, () => this.savingFlag = false);
}
DownloadAttendanceReport() {
  // Format dates only if they are selected
  if (this.data.start_date) {
      this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
  }


  this.savingFlag = true;

  this.serve.post_rqst(
      {
          "start_date": this.data.start_date || '',
        
      },
      "Excel/AttendanceDailyReport"
  ).subscribe((result: any) => {
      this.savingFlag = false;
      if (result['msg'] == true) {
          window.open(this.serve.downloadUrl + result['filename']);
      }
  }, () => this.savingFlag = false);
}


  getSalesUser(searcValue) {
    this.serve.post_rqst({ 'search': searcValue }, "CustomerNetwork/salesUserList").subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }
  distributorDetail() {
    let id = { "id": this.data.drId }
    this.serve.post_rqst(id, "CustomerNetwork/distributorDetail").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.data = result['distributor_detail'];
        this.data.id = result['distributor_detail']['id'];
        this.data.assigned_sales_user_name = this.data['assigned_sales_user_name'].map(String);
        this.data.distributor_id=this.data['distributor_id'].map(String);
        let newArr = this.data['distributors'];
        console.log(newArr)
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    }
    )
   }
  distributorList(searcValue, state) {
    this.serve.post_rqst({ 'search': searcValue, 'state': state }, "CustomerNetwork/distributorsList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }

  allCustomerNetworkList(searcValue) {
    this.drlist = [];
    this.serve.post_rqst({ 'search': searcValue, 'type': this.data.drType, 'employee_id': this.data.employee_id }, "Travel/drList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['result'];
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }


  getSegment() {
    this.serve.post_rqst({}, "Master/getProductCategoryList").subscribe((result => {
      if (result['category_list']['statusCode'] == 200) {
        this.segmentList = result['category_list']['segment_list'];
      }
      else {
        this.savingFlag = false;
        this.toast.errorToastr(result['category_list']['statusCode'])
      }
    }))
  }
  UpdateSalesUser() {
    this.savingFlag = true;
    setTimeout(() => {
      this.serve.post_rqst({ 'drId': this.data.id, 'userArray': this.data.assigned_sales_user_name, 'company_name': this.data.company_name }, "CustomerNetwork/drUserAssign").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.dialog.closeAll();
          this.savingFlag = false;
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.savingFlag = false;
          this.toast.errorToastr(result['statusMsg'])
        }
      }))
    }, 2000);
  }
  // distArray(data){
  //   this.assignDistArray = []
  //   let index = this.drlist.findIndex(row => row.id == data)
  //   if(index != -1){
  //     this.assignDistArray.push(this.drlist[index].id)
  //   }
  // }
  UpdateDistributor() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'drId': this.data.id, 'distributorId': this.data.distributor_id }, "CustomerNetwork/dealerDistributorAssign").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }
  UpdateCustomerNetworkTravel() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'id': this.data.id, 'dr_id': this.data.distributor_id }, "Travel/drChange").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    }))
  }

  add_segment() {
    this.savingFlag = true;
    this.data.created_by_name = this.userName;
    this.data.created_by_id = this.userId;
    this.serve.post_rqst(this.data, "Master/addCategory").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
        this.savingFlag = false;
        this.dialogRef.close(true)
        this.serve.count_list();
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }))

  }
  add_subCategory() {
    this.savingFlag = true;
    this.data.created_by_name = this.userName;
    this.data.created_by_id = this.userId;
    this.serve.post_rqst(this.data, "Master/addSubCategory").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
        this.savingFlag = false;
        this.dialogRef.close(true)
        this.serve.count_list();
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }))

  }

  updateTarget() {
    let header;
    if(this.data.from=='secondarySaleTarget'){
      header = "Target/updateDistributorsSecondaryTarget "
    }else{
      header = "Target/updateDistributorsPrimaryTarget"
    }
    this.serve.post_rqst({ 'id': this.data.id, 'target': this.data.target }, header).subscribe(result => {
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg'])
        this.dialog.closeAll();
      }
      else {
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    }, () => {

      this.savingFlag = false;
      this.toast.errorToastr('Something went wrong')
    })
  }

  partial_dispatch(){

    this.data.partial_amount='';
    this.data.partial_dispatch_date='';
  }

  Dispatch_planed(){

    this.data.reason='';
  } 


  
  MobileNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }

  }
  

  site_status_change1() {
    this.savingFlag = true;
      this.serve.post_rqst({ 'partcipantName': this.data.partcipantName,'partcipantType': this.data.partcipantType, 'participantMobile':this.data.participantMobile, 'eventId': this.data.EventId}, "Event/addNewParticipantsWeb").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.savingFlag = false;
          this.dialog.closeAll();
          this.toast.successToastr(result['statusMsg']);
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
  }
}
